function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    id: "\\u5F62\\u72B6_1_1_",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381.604,270.943c-0.585-58.285,47.526-86.241,49.673-87.647    c-27.032-39.536-69.153-44.961-84.15-45.572c-35.81-3.645-69.92,21.096-88.095,21.096c-18.129,0-46.203-20.566-75.902-20.046    c-39.08,0.585-75.09,22.731-95.201,57.711c-40.577,70.387-10.375,174.71,29.162,231.845c19.334,27.92,42.385,59.346,72.624,58.195    c29.152-1.151,40.158-18.859,75.391-18.859c35.234,0,45.135,18.859,75.968,18.266c31.343-0.567,51.216-28.459,70.395-56.496    c22.185-32.44,31.326-63.848,31.865-65.446C442.656,363.678,382.232,340.526,381.604,270.943z M323.665,99.913    c16.037-19.471,26.904-46.531,23.955-73.464c-23.151,0.94-51.171,15.389-67.784,34.842    c-14.887,17.261-27.909,44.741-24.421,71.189C281.232,134.481,307.572,119.348,323.665,99.913z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1B1B1B"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.caad5e92a33d00f1ca009e4c54671ceb.svg";
export { ForwardRef as ReactComponent };